import { combineReducers } from 'redux';

import {
  ADD_VALUE_TO_SEGMENT,
  RESET_SEGMENT,
  SET_IS_FETCHING,
  UNSET_IS_FETCHING,
} from './actionTypes';
import {
  NET_SERVICE_REVENUE_SEGMENT,
  NEW_CUSTOMERS_SEGMENT,
  NET_PRODUCT_REVENUE_SEGMENT,
  SERVICE_COUNT_SEGMENT,
  PRODUCT_COUNT_SEGMENT,
  TOTAL_REVENUE_SEGMENT,
  TOTAL_REVENUE_WITH_TAX_SEGMENT,
} from './constants';

const initialState = {
  first: null,
  second: null,
};

const analyticsSegment = segment => (state = { ...initialState }, { type, payload }) => {
  switch (type) {
    case RESET_SEGMENT(segment):
      return { ...initialState };

    case ADD_VALUE_TO_SEGMENT(segment):
      return {
        ...state,
        [payload.key]: state[payload.key] + payload.value,
      };

    default:
      return state;
  }
};

const totalRevenue = analyticsSegment(TOTAL_REVENUE_SEGMENT);
const totalRevenueWithTax = analyticsSegment(TOTAL_REVENUE_WITH_TAX_SEGMENT);
const netServiceRevenue = analyticsSegment(NET_SERVICE_REVENUE_SEGMENT);
const serviceCount = analyticsSegment(SERVICE_COUNT_SEGMENT);
const netProductRevenue = analyticsSegment(NET_PRODUCT_REVENUE_SEGMENT);
const productCount = analyticsSegment(PRODUCT_COUNT_SEGMENT);
const newCustomers = analyticsSegment(NEW_CUSTOMERS_SEGMENT);


const isFetching = (state = [], { type, payload }) => {
  if (type === SET_IS_FETCHING) {
    return [...state.filter(item => item !== payload), payload];
  }
  if (type === UNSET_IS_FETCHING) {
    return [...state.filter(item => item !== payload)];
  }
  return state;
};

const analytics = combineReducers({
  totalRevenue,
  totalRevenueWithTax,
  netServiceRevenue,
  serviceCount,
  netProductRevenue,
  productCount,
  newCustomers,
  isFetching,
});

export default analytics;
